import './missionsDisplay.scss';
import type { Maybe } from '@custom/dx3';
import { useMemo } from 'react';
import { COPY } from '../../../assets/copy/copy';
import { Astronaut } from '../../../assets/svgs/index.js';
import type { Scalars } from '../../../models/__generated__/graphql';
import type {
  MissionLockedStatus,
  Reward,
} from '../../../store/queries/fragments/mission/missionSubFragments.js';
import { CardView } from './CardView';

export type MissionsDisplayProps = {
  missions: Array<{
    id: string;

    startDate: Maybe<Scalars['ISODate']['input']>;
    endDate: Maybe<Scalars['ISODate']['input']>;
    expiringDate: Maybe<Scalars['ISODate']['input']>;
    expiringSoon: Maybe<boolean>;
    featured: Maybe<boolean>;
    repeats: Maybe<boolean>;
    inProgress: Maybe<boolean>;

    name: Maybe<string>;
    iconImageUrl: Maybe<string>;

    rewards?: null | readonly Reward[];
    lockedStatus: Maybe<MissionLockedStatus>;

    iLike: Maybe<boolean>;
    totalLikes: Maybe<number>;
  }>;
  setLike: (id: string, like: boolean) => Promise<void>;
};

export function MissionsDisplay({
  missions,
  setLike,
}: MissionsDisplayProps): JSX.Element {
  const noMissions = useMemo(() => {
    return (
      <div className="no-missions">
        <Astronaut
          width="256"
          height="256"
          style={{ filter: 'drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.2))' }}
        />
        <h2 className="bold">{COPY.MISSIONS.NO_MISSIONS.HEADER}</h2>
        <h4>{COPY.MISSIONS.NO_MISSIONS.SUB_HEADER}</h4>
      </div>
    );
  }, []);

  return (
    <div className="missions-display-wrapper">
      {missions.length === 0 ? (
        noMissions
      ) : (
        <CardView missions={missions} setLike={setLike} />
      )}
    </div>
  );
}
